<p>Test auth Providers!</p>

<router-outlet></router-outlet>
